import input from '../../../../input';

const dark = (params) => input.borderColor.default.dark(params);

export default dark;
